export default __webpack_public_path__ + "static/media/pin_stop.efdd2e87.svg";